"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEstateState = void 0;
var EstateState_1 = require("@/pages/estate/states/EstateState");
var EstateTranslate_init_1 = require("@/pages/estate/states/EstateTranslate.init");
var EstateChartState_init_1 = require("@/pages/estate/states/EstateChartState.init");
var BuildingState_init_1 = require("@/pages/place/states/BuildingState.init");
var TransactionRecord_init_1 = require("@/pages/estate/states/TransactionRecord.init");
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var GoogleMap_1 = require("@/api/vendor/GoogleMap");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var PlaceTranslate_init_1 = require("@/pages/place/states/PlaceTranslate.init");
var EstateBlock_init_1 = require("@/pages/estate/states/EstateBlock.init");
exports.defaultEstateState = {
    id: 11,
    isSticky: false,
    t: EstateTranslate_init_1.defaultEstateTranslateState,
    tFeature: BuildingState_init_1.defaultBuildingState.tFeature,
    tPlace: PlaceTranslate_init_1.defaultPlaceTranslate,
    type: EstateState_1.EstatePhaseType.ESTATE,
    address: '1 South Horizons Drive, Aberdeen, Hong Kong',
    parentName: 'Lei King Wan',
    builtYear: 1988,
    parentUrl: '#test',
    url: '#estate',
    name: 'South Horizons',
    nameAlt: '海怡半島',
    districtName: 'Aberdeen',
    districtId: 1,
    charts: EstateChartState_init_1.defaultEstateChartsState,
    phases: EstateBlock_init_1.southHorizonsPhase,
    images: [
        'https://images.okay.com/Property/Folder150/regent-height-western-district-for-sale-212778_637292860890865590.jpg',
    ],
    lat: 22.2440841,
    lng: 114.1472304,
    viewRentLink: '#',
    viewSaleLink: '#',
    ppsf: 16789,
    ppsfIsSa: true,
    ppsfMin: 14567,
    ppsfMax: 23456,
    ppsfTime: 'July 2020',
    ppsfCompareTo: 'Jun',
    ppsfChangePercent: 2.8,
    transactionPriceMin: 7.89,
    transactionPriceMax: 14.567,
    transactionTime: 'July 2020',
    transactionCount: 42,
    transactionCountChangePercent: 2.8,
    transactionCountCompareTo: 'Jun',
    forSaleCount: 42,
    forRentCount: 32,
    description: 'Located in the Cyberport on Telegraph Bay, Bel-Air is a Pokfulam luxury residence with panoramic sea views. A project by Pacific Century Premium Developments, the residences were completed between 2004 and 2008. Bel-Air is a massive estate with mansions and houses split into six phases for sale and rental. Phases 1 and 2 were built in pairs in a wide and undulating curvature shape, both comprise seven towers with 34 to 45 residential floors, housing two to three units per floor. All come with a balcony and saleable sizes ranging from 598 to 1,956 sq. ft. with duplex units over 2,000 sq. ft. occupying the top floors with a flat roof. Another phase is right next door, featuring 18 detached seafront houses.\n\nPhases 4 and 6 both have eight towers as well as 26 to 40 floors containing one to four units each. Saleable areas for regular units range from 459 to 3,846 sq. ft. All come with a balcony or flat roof with duplex units on the top. Phase 5 is named “Villa Bel-Air” and features 29 deluxe houses and mansions, some with their own internal lifts and private swimming pool. The clubhouse - “Club Bel-Air” spans 127,000 sq. ft. and comprises a \'Bay Wing\' (over 87,000 sq.ft.) and \'Peak Wing\' (over 40,000 sqft), offering a host of comprehensive facilities. There is also a 1,100,000 sq.ft. landscaped area and outdoor facilities, making it one of the most extraordinary clubhouses in Hong Kong.',
    totalBlockCount: 61,
    totalUnitCount: 1234,
    schoolNetPrimary: '95',
    schoolNetSecondary: 'Aberdeen',
    features: [1, 2, 3, 4, 5],
    transactions: TransactionRecord_init_1.defaultTransactionRecords,
    blocks: EstateBlock_init_1.southHorizons,
    pixelWidth: 400,
    galleryFullWidth: '400px',
    galleryIndex: 0,
    galleryPop: PlaceState_1.GalleryPopState.NONE,
    mapType: GoogleMap_1.GoogleMapType.ROADMAP,
    availablePropertiesRent: ResultPageState_init_1.newForRent,
    availablePropertiesSale: ResultPageState_init_1.forSaleOnly,
    availableRentSort: PlaceState_1.AvailableSortType.QUALITY_SCORE,
    availableRentOrder: PlaceState_1.AvailableSortOrder.DESC,
    availableSaleSort: PlaceState_1.AvailableSortType.QUALITY_SCORE,
    availableSaleOrder: PlaceState_1.AvailableSortOrder.DESC,
    availableShowBuildingName: false,
    isLegacyChart: false,
    isLegacyTransaction: false,
};
